const shouldNotForwardProps = (propNames) => ({
  shouldForwardProp: (propName) => !propNames.includes(propName)
});
export {
  shouldNotForwardProps
};
//# sourceMappingURL=shouldNotForwardProps.js.map
